'use client';

// Installeert de fetch-poort (lib/api-fetch-gate.mjs) voor de hele app: bootstrap
// en de primaire gegevens van het scherm eerst, de overige GET's naar /api/ met
// hooguit vier tegelijk erachteraan (PERFORMANCE.md, Startup contract).
//
// useLayoutEffect en geen useEffect: React draait passieve effecten van kinderen
// voor die van de ouder en van eerdere broers voor latere. Met useEffect zou de
// pagina (die voor deze component in de layout staat) zijn mount-fetches al
// afvuren voordat de poort er is. Alle layout-effecten draaien voor alle passieve.

import { useLayoutEffect } from 'react';
import { installFetchGate } from '@/lib/api-fetch-gate.mjs';

export default function FetchGate() {
  useLayoutEffect(() => installFetchGate(window), []);
  return null;
}
